import { defineStore } from 'pinia';
import { loadSellerInfo } from '@/api/home/seller';

interface SellerSiteState {
  /** 档口独立站项目绑定的档口详情（首页拉取，持久化缓存） */
  info: API.SellerInfoResponse | null
}

export const useSellerSiteStore = defineStore({
  id: 'sellerSite',
  state: (): SellerSiteState => ({
    info: null,
  }),
  getters: {
    /** 项目绑定的档口 id（不是登录用户所属档口 userStore.sellerId） */
    sellerId(): number | undefined {
      return this.info?.id || undefined;
    },
  },
  actions: {
    /**
     * 获取档口详情：已有缓存且非强制刷新时直接返回缓存，否则请求接口并写入缓存
     */
    async fetchSellerInfo(force = false): Promise<API.SellerInfoResponse | null> {
      if (this.info && !force) return this.info;
      const res = await loadSellerInfo();
      if (res) {
        this.info = res;
      }
      return this.info;
    },
  },
  persist: true,
});
